export const REGISTRATION_ENDPOINTS = {
    register: `/register`,
    groups: `/groups?tenant=NRAIT`,
};
